<template>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
    <a
      :href="type.publicUrl"
      @click.prevent="openConfiguratorUrl(type.publicUrl)"
      class="tw-relative card model-car model-card mb-4 h-auto cursor-pointer text-decoration-none"
    >
      <img
        :src="carImage"
        class="card-img-top"
        :alt="generateTypeAltText()"
      >
      <div class="card-body d-flex flex-column">
        <h4 class="h3 card-title mb-1 text-primary">
          {{ type.name }}
        </h4>
        <div class="mb-2">
          <p class="card-text mb-1">
            <strong>Teljesítmény:</strong> {{ type.ph }}
          </p>
          <p class="card-text mb-1">
            <strong>Üzemanyag:</strong> {{ type.fuelType || '' }}
          </p>
          <p class="card-text mb-1">
            <strong>Váltó:</strong> {{ type.transType || '' }}
          </p>
          <p class="card-text mb-1">
            <strong>Ülések száma:</strong> {{ type.TYPSeat ? `${type.TYPSeat} fő` : '' }}
          </p>
        </div>
        <div class="mb-3">
          <p class="card-text text-muted">
            <strong>Listaár:</strong> {{ listPrice }}
          </p>
        </div>
        <button
          type="button"
          class="btn btn-block btn-primary btn-sm mt-auto"
        >
          <template v-if="type.minPrice && type.minPrice !== 'Hívjon bennünket!'">
            {{ type.minPrice }}
          </template>
          <template v-else>
            Hívjon bennünket!
          </template>
        </button>
      </div>
    </a>
  </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class TypeCard extends Vue {

  @Prop(Object) type;
  @Prop(String) page;

  get carImage() {
    return this.type.modelImage || 'https://irp-cdn.multiscreensite.com/a769bb7b/dms3rep/multi/tablet/Car-Servicing-pg-img1-960x600.jpg';
  }

  get carMake() {
    return this.type.model && this.type.model.make ? this.type.model.make.name : 'Autó';
  }

  get carModel() {
    return this.type.model ? this.type.model.name : '';
  }

  get listPrice() {
    // Show empty string for cars that display "Hívjon bennünket!"
    if (this.type.minPrice === 'Hívjon bennünket!') {
      return '';
    }
    return this.type.grossPrice || '';
  }

  openConfiguratorUrl(url) {
    if (url && url.trim() !== '') {
      location.href = url;
    }
  }

  generateTypeAltText() {
    const makeName = this.carMake;
    const modelName = this.carModel;
    const typeName = this.type.name || '';
    
    return `${makeName} ${modelName} ${typeName} lízing`;
  }
}
</script>

<style scoped>
.model-card:hover {
  text-decoration: none;
}

.card-text {
  color: #676868;
}

.cursor-pointer {
  cursor: pointer;
}

.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>